import React, {FC, PropsWithChildren, useRef} from 'react';
import {Scrollbar} from '@priority-software/priority-style-react';
import {isRTL} from '../../../../Localization';
import styles from './RoutesWrapper.module.scss';
import {useScrollWrapper} from './useScrollWrapper';

export const RoutesWrapper: FC<PropsWithChildren> = ({children}) => {
    const isRtl = isRTL();
    const scrollbarRef = useRef<any>();
    useScrollWrapper(scrollbarRef);

    return (
        <Scrollbar
            scrollbarRef={scrollbarRef}
            rtl={isRtl}
            componentClasses={styles.routesMainScroll}
        >
            {children}
        </Scrollbar>
    );
};
